import { Avatar, Row } from 'antd';
import Text from 'components/Text';
import { StaffGroupTone, toneChip, toneRing } from './useStaffGroupTone';

type Props = {
  name: string;
  avatar?: string;
  /** Staff Group color; the avatar gets a ring and the name a pill in it. */
  tone?: StaffGroupTone;
};

/** Avatar + name row used as a staff search/dropdown option. */
const StaffOptionLabel = ({ name, avatar, tone }: Props) => (
  <Row align={'middle'}>
    <Avatar src={avatar} style={toneRing(tone)}>{name?.[0] || ''}</Avatar>
    <Text ml={1} variant="CONTENT_2" color="text_3">
      <span style={toneChip(tone)}>{name}</span>
    </Text>
  </Row>
);

export default StaffOptionLabel;
